<modal
  [id]="modalId"
  [header]="'Adding event apps'"
  [closeButtonEnabled]="true"
  [widthClass]="'tw-w-full tw-max-w-[calc(100vw-2rem)] lg:tw-w-[1184px]'"
  [heightClass]="'tw-h-auto tw-max-h-[90vh]'"
  [showFooterDivider]="false"
  [headerIcon]="plusIcon"
  (onCloseModal)="onModalClosed()"
>
  <div slot="body" class="tw-m-auto tw-px-1 tw-pb-2">
    <div class="event-apps-modal-grid">
      @for (service of services; track service.id) {
      <div class="event-apps-modal-card tw-group tw-flex tw-flex-col tw-overflow-hidden tw-text-left tw-transition-shadow hover:tw-shadow-md">
        <div class="tw-relative tw-aspect-video tw-w-full tw-shrink-0 tw-overflow-hidden tw-bg-gray-100">
          @if (hasVideo(service)) {
            @if (isTutorialPlaying(service)) {
              @if (youtubeVideoId(service); as videoId) {
              <iframe
                class="tw-h-full tw-w-full tw-border-0"
                [src]="youtubeEmbedSrc(videoId)"
                [title]="service.title + ' tutorial video'"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
                allowfullscreen="true"
                webkitallowfullscreen="true"
                mozallowfullscreen="true"
                referrerpolicy="strict-origin-when-cross-origin"
              ></iframe>
              } @else {
                @if (directVideoUrl(service); as videoSrc) {
                <video
                  class="tw-h-full tw-w-full tw-bg-black"
                  [src]="videoSrc"
                  [attr.aria-label]="service.title + ' tutorial video'"
                  controls
                  autoplay
                  playsinline
                ></video>
                }
              }
            } @else {
            <button
              type="button"
              class="tw-relative tw-block tw-h-full tw-w-full tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-0"
              [attr.aria-label]="'Play ' + service.title + ' video'"
              (click)="onPlayTutorial(service, $event)"
            >
              <img
                [src]="heroImageSrc(service)"
                [alt]="service.title + ' video thumbnail'"
                class="tw-h-full tw-w-full tw-object-center"
                [ngClass]="heroObjectFitClass(service)"
                loading="lazy"
              />
              <div class="tw-pointer-events-none tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-black/10">
                <span class="tw-flex tw-h-11 tw-w-11 tw-items-center tw-justify-center tw-rounded-full tw-bg-white/95 tw-shadow-md tw-ring-1 tw-ring-black/5" aria-hidden="true">
                  <i class="fas fa-play tw-ms-0.5 tw-text-sm tw-text-gray-800"></i>
                </span>
              </div>
            </button>
            }
          } @else if (service.coverImageUrl) { @if (hasWebsite(service)) {
          <button
            type="button"
            class="tw-block tw-h-full tw-w-full tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-0"
            [attr.aria-label]="'Open ' + service.title + ' website'"
            (click)="openWebsite(service, $event)"
          >
            <img
              [src]="service.coverImageUrl"
              [alt]="service.title + ' cover'"
              class="tw-h-full tw-w-full tw-object-center"
              [ngClass]="heroObjectFitClass(service)"
              loading="lazy"
            />
          </button>
          } @else {
          <img
            [src]="service.coverImageUrl"
            [alt]="service.title + ' cover'"
            class="tw-pointer-events-none tw-h-full tw-w-full tw-object-center"
            [ngClass]="heroObjectFitClass(service)"
            loading="lazy"
          />
          } } @else { @if (hasWebsite(service)) {
          <button
            type="button"
            class="tw-block tw-h-full tw-w-full tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-0"
            [attr.aria-label]="'Open ' + service.title + ' website'"
            (click)="openWebsite(service, $event)"
          >
            <img [src]="service.logo" [alt]="service.title" class="tw-h-full tw-w-full tw-object-center tw-p-6" [ngClass]="heroObjectFitClass(service)" loading="lazy" />
          </button>
          } @else {
          <img
            [src]="service.logo"
            [alt]="service.title"
            class="tw-pointer-events-none tw-h-full tw-w-full tw-object-center tw-p-6"
            [ngClass]="heroObjectFitClass(service)"
            loading="lazy"
          />
          } }
        </div>

        <div class="tw-flex tw-flex-1 tw-flex-col tw-gap-2 tw-px-3 tw-pt-3 tw-pb-2">
          <div class="tw-flex tw-items-center tw-gap-2 tw-min-w-0">
            <img [src]="iconSrc(service)" [alt]="service.title" class="tw-h-4 tw-w-4 tw-shrink-0 tw-object-contain" loading="lazy" />
            <h3 class="tw-min-w-0 tw-font-inter tw-text-sm tw-font-bold tw-leading-snug tw-text-gray-700 tw-truncate">{{ service.title }}</h3>
          </div>
          <p
            #descTruncation="appTruncationDetector"
            appTruncationDetector
            class="tw-font-inter tw-text-xs tw-leading-snug tw-text-gray-500 tw-line-clamp-3"
            [ngxTippy]="descTruncation.isTruncated() ? descriptionText(service) : null"
            [tippyProps]="{ maxWidth: 280, theme: 'dark' }"
          >
            {{ descriptionText(service) }}
          </p>
        </div>

        <div class="tw-mt-auto tw-px-3 tw-pb-3">
          @if (service.requiresApproval) {
          <button
            type="button"
            class="tw-flex tw-w-full tw-items-center tw-justify-center tw-gap-2 tw-rounded-md tw-border-0 tw-bg-blue-600 tw-py-2.5 tw-font-inter tw-text-sm tw-font-medium tw-text-white tw-shadow-sm hover:tw-bg-blue-700 disabled:tw-cursor-not-allowed disabled:tw-opacity-70"
            [disabled]="isRequesting(service)"
            (click)="onServiceAction(service)"
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <g [attr.clip-path]="'url(#event-apps-lock-' + service.id + ')'">
                <path
                  d="M9.04892 0.0113279C8.36294 0.0964988 7.73286 0.432711 7.2803 0.955056C6.82774 1.4774 6.5848 2.14884 6.59838 2.83974V4.19995H1.20036C0.882005 4.19995 0.576688 4.32638 0.351577 4.55143C0.126466 4.77647 0 5.0817 0 5.39996V10.8C0 11.1183 0.126466 11.4235 0.351577 11.6485C0.576688 11.8736 0.882005 12 1.20036 12H8.40252C8.72088 12 9.02619 11.8736 9.2513 11.6485C9.47642 11.4235 9.60288 11.1183 9.60288 10.8V5.39996C9.60288 5.0817 9.47642 4.77647 9.2513 4.55143C9.02619 4.32638 8.72088 4.19995 8.40252 4.19995H7.79874V2.80794C7.78842 2.41991 7.92186 2.04174 8.17343 1.74605C8.425 1.45037 8.77697 1.25802 9.16175 1.20594C9.36953 1.18683 9.57901 1.21125 9.77681 1.27765C9.97461 1.34405 10.1564 1.45096 10.3105 1.59156C10.4647 1.73216 10.5878 1.90335 10.672 2.09419C10.7562 2.28504 10.7997 2.49135 10.7996 2.69994V4.79996C10.7996 4.95909 10.8629 5.1117 10.9754 5.22422C11.088 5.33675 11.2406 5.39996 11.3998 5.39996C11.559 5.39996 11.7117 5.33675 11.8242 5.22422C11.9368 5.1117 12 4.95909 12 4.79996V2.69994C11.9996 2.3244 11.9209 1.95306 11.7689 1.60961C11.617 1.26616 11.3951 0.958133 11.1174 0.705173C10.8398 0.452212 10.5124 0.259868 10.1563 0.140405C9.80014 0.0209425 9.423 -0.0230176 9.04892 0.0113279ZM5.40162 9.10018C5.40162 9.25931 5.33839 9.41193 5.22583 9.52445C5.11328 9.63697 4.96062 9.70019 4.80144 9.70019C4.64226 9.70019 4.48961 9.63697 4.37705 9.52445C4.26449 9.41193 4.20126 9.25931 4.20126 9.10018V7.30017C4.20126 7.14104 4.26449 6.98843 4.37705 6.87591C4.48961 6.76338 4.64226 6.70017 4.80144 6.70017C4.96062 6.70017 5.11328 6.76338 5.22583 6.87591C5.33839 6.98843 5.40162 7.14104 5.40162 7.30017V9.10018Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath [attr.id]="'event-apps-lock-' + service.id">
                  <rect width="12" height="12" fill="white" />
                </clipPath>
              </defs>
            </svg>
            {{ isRequesting(service) ? 'Requesting...' : 'Request access' }}
          </button>
          } @else {
          <button
            type="button"
            class="tw-flex tw-w-full tw-items-center tw-justify-center tw-gap-1.5 tw-rounded-md tw-border-0 tw-bg-blue-600 tw-py-2.5 tw-font-inter tw-text-sm tw-font-medium tw-text-white tw-shadow-sm hover:tw-bg-blue-700 disabled:tw-cursor-not-allowed disabled:tw-opacity-70"
            [disabled]="isAdding(service)"
            (click)="onServiceAction(service)"
          >
            <i class="fas fa-plus tw-text-xs tw-opacity-95" aria-hidden="true"></i>
            {{ isAdding(service) ? 'Adding...' : 'Add to my event' }}
          </button>
          }
        </div>
      </div>
      }
    </div>
  </div>
</modal>

@if (isAccessRequestModalOpen()) {
<delete-modal
  [id]="accessRequestModalId"
  [message]="accessRequestConfirmMessage"
  [confirmBtnBgColorClass]="'tw-bg-blue-600 hover:tw-bg-blue-700 focus:tw-ring-blue-300'"
  [confirmBtnLabel]="'Confirm'"
  [cancelBtnLabel]="'Cancel'"
  (onDelete)="onAccessRequestConfirmed()"
  (onCancel)="onAccessRequestCancelled()"
></delete-modal>
}
